import React from "react";
import { LOGO_BLUE, NAV } from "@/lib/site";

export const Footer = ({ onQuote }) => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-royal text-white overflow-hidden grain">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24 lg:pt-32 pb-12">
        <button
          data-testid="footer-quote-btn"
          onClick={onQuote}
          className="block text-left font-display font-semibold tracking-tighter leading-[0.85] text-[16vw] lg:text-[12vw] hover:text-white/80 transition-colors duration-500"
        >
          Let&rsquo;s talk.
        </button>

        <div className="mt-20 grid gap-12 md:grid-cols-12 border-t border-white/15 pt-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img src={LOGO_BLUE} alt="Fascinated by Floors" className="h-14 w-14 object-contain rounded-md" />
              <div>
                <div className="font-display text-xl">Fascinated by Floors</div>
                <div className="text-xs tracking-[0.24em] uppercase text-white/60">Beyond Expectations</div>
              </div>
            </div>
            <p className="mt-6 max-w-sm text-white/70 leading-relaxed">
              The finest flooring, ceiling and terracotta facade systems from the world&rsquo;s
              leading manufacturers &mdash; for residential, hospitality and commercial spaces.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.24em] uppercase text-white/50 mb-5">Explore</div>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a
                    data-testid={`footer-nav-${n.label.toLowerCase()}`}
                    href={n.href}
                    className="text-white/80 hover:text-white transition-colors duration-300"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs tracking-[0.24em] uppercase text-white/50 mb-5">Get in touch</div>
            <a href="mailto:sales@fascinatedbyfloors.com" className="block text-white/80 hover:text-white transition-colors duration-300">sales@fascinatedbyfloors.com</a>
            <a href="tel:+919266884224" className="block mt-2 text-white/80 hover:text-white transition-colors duration-300">+91 92668 84224</a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-center justify-between gap-4 text-white/50 text-sm">
          <span>© {year} Fascinated by Floors. All rights reserved.</span>
          <span>Beyond Floors. Beyond Expectations.</span>
        </div>
      </div>
    </footer>
  );
};
